import { datadogRum } from '@datadog/browser-rum';
import { APPLICATION_ID, CLIENT_TOKEN } from 'constants/datadog';
import envDetect from '@tcc/env-detect';

// Accounts like the ones used in synthetic testing do not report errors to Datadog to avoid
// polluting the data we get.
const blacklistedAccounts = ['895441', '896702', '897391', '897620', '903817'];

const initDataDog = (userId: string) => {
  // Disable Datadog for local and Pipelines envirornments.
  const isDevelopment = envDetect.getCurrentEnv() === envDetect.environments.LOCAL;
  if (isDevelopment || blacklistedAccounts.includes(userId)) return;
  datadogRum.init({
    applicationId: APPLICATION_ID,
    clientToken: CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'filedview-web---script-creator',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: false,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
    env: process.env.NODE_ENV,
    version: process.env.npm_package_version,
    trackViewsManually: true,
    allowedTracingUrls: [
      'https://api.climate.com/api/hank/',
      'https://local.climate.com/api/hank/',
      'https://ol.na.climate.com/v2/graphql',
      'https://local.climate.com/v2/graphql',
      'https://api.climate.com/api/groot/'
    ]
  });

  datadogRum.setUser({ id: userId });
};

export default initDataDog;
    